// Integración con el carrito de Shopify.
//
// Cuando el configurador corre DENTRO de la tienda (tema de Shopify), al pulsar
// "Comprar" hace un POST nativo a /cart/add con:
//   • La variante correcta según Acabado × Metacrilato (mapa VARIANT_MAP).
//   • Todas las opciones como propiedades de línea (texto) → visibles en el pedido.
//   • Una imagen PNG del diseño como propiedad de tipo archivo → miniatura en el pedido.
//
// Cuando corre fuera de Shopify (preview en este editor), window.Shopify no existe,
// así que el botón usa el carrito interno de demostración.

(function () {
  // --- IDs reales de variante del producto "Tapa de encendido AM6 personalizada" ---
  // 2 opciones: Efecto superficial (Mate/Galaxy) × Metacrilato (Sin/Con) = 4 variantes.
  // clave: `${finish}|${metacryl}`  →  ID numérico de variante
  const VARIANT_MAP = {
    'matte|no':   '56348825911631', // Mate / Sin metacrilato          — 28,00 €
    'matte|yes':  '57893636571471', // Mate / Con metacrilato           — 32,00 €
    'galaxy|no':  '56348825878863', // Galaxy / Sin metacrilato         — 31,50 €
    'galaxy|yes': '57893636604239', // Galaxy / Con metacrilato         — 35,50 €
  };

  // ¿Estamos dentro de una tienda Shopify?
  function isShopify() {
    return typeof window.Shopify !== 'undefined' && !!window.Shopify.shop;
  }
  window.IS_SHOPIFY = isShopify();

  // Genera un PNG del diseño a partir del nodo de la previsualización.
  // Usa html-to-image (embebe fuentes y estilos) para que la miniatura sea fiel.
  async function buildPreviewPng() {
    const node = document.querySelector('.preview-cover');
    if (!node || !window.htmlToImage) return null;
    try {
      const blob = await window.htmlToImage.toBlob(node, {
        pixelRatio: 1.6,
        backgroundColor: '#ffffff',
        cacheBust: true,
      });
      return blob;
    } catch (e) {
      console.warn('[shopify-cart] No se pudo generar el PNG:', e);
      return null;
    }
  }

  // Construye la lista de propiedades de línea (texto) a partir del resumen.
  function buildProperties(summaryLines, config) {
    const props = {};
    summaryLines.forEach((s) => {
      if (s.label === 'Producto') return; // ya es el título del producto
      props[s.label] = s.value || '—';
    });
    props['Tamaño Instagram'] = Math.round((config.instagramScale ?? 1) * 100) + '%';
    if (config.notes && config.notes.trim()) {
      props['Comentarios'] = config.notes.trim();
    }
    return props;
  }

  // Añade el diseño al carrito de Shopify (POST multipart con archivo).
  // Hace navegación completa a /cart al terminar.
  async function addToShopifyCart({ config, summaryLines, onError }) {
    const variantId = VARIANT_MAP[`${config.finish}|${config.metacryl}`];
    if (!variantId) {
      onError && onError('No se encontró la variante para ' + config.finish + '/' + config.metacryl);
      return;
    }

    const pngBlob = await buildPreviewPng();

    // Form nativo multipart → Shopify sube el archivo y lo adjunta a la línea.
    const form = document.createElement('form');
    form.action = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') + 'cart/add';
    form.method = 'post';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    const addHidden = (name, value) => {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = name;
      i.value = value;
      form.appendChild(i);
    };

    addHidden('id', variantId);
    addHidden('quantity', '1');

    const props = buildProperties(summaryLines, config);
    Object.entries(props).forEach(([k, v]) => addHidden(`properties[${k}]`, v));

    // Imagen del diseño como propiedad de tipo archivo.
    if (pngBlob) {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = 'properties[Diseño]';
      const fileName = `tapa-am6-${Date.now()}.png`;
      const file = new File([pngBlob], fileName, { type: 'image/png' });
      const dt = new DataTransfer();
      dt.items.add(file);
      fileInput.files = dt.files;
      form.appendChild(fileInput);
    }

    document.body.appendChild(form);
    form.submit();
  }

  window.ShopifyCart = { isShopify, addToShopifyCart, VARIANT_MAP };
})();
